import React from 'react'
import { MANUAL_VERSIONS, ManualVersion } from '../../../versioning'
import * as S from '../styled'
import useUser from '@common/hooks/useUser'

interface ManualVersionModalProps {
  isVisible: boolean
  onClose: () => void
  onContinue: () => void
  selectedVersion: string | null
  onVersionChange: (version: ManualVersion) => void
}

// for some reason, the built in toReversed() method doesn't work
function reversedManualVersions(versions: ManualVersion[]) {
  const reversedArray: ManualVersion[] = []
  for (let i = versions.length - 1; i >= 0; i--) {
    const valueAtIndex = versions[i]
    reversedArray.push(valueAtIndex)
  }
  return reversedArray
}

const ManualVersionModal: React.FC<ManualVersionModalProps> = ({
  isVisible,
  onClose,
  onContinue,
  selectedVersion,
  onVersionChange,
}) => {
  if (!isVisible) return null

  const formatVersion = (version: string) => {
    return version.replace(/_/g, '.')
  }

  const displayVersions = reversedManualVersions([...MANUAL_VERSIONS])

  return (
    <S.ModalOverlay>
      <S.ModalBackdrop onClick={onClose} />
      <S.ModalContent>
        <S.ModalTitle>Select Manual Version</S.ModalTitle>
        <S.ModalDescription>
          Please select which manual version to use for this evaluation:
        </S.ModalDescription>

        <S.VersionOptionsList>
          {displayVersions.map((version, index) => (
            <S.VersionOption
              key={version}
              isSelected={selectedVersion === version}
            >
              <S.VersionRadio
                type="radio"
                name="manualVersion"
                value={version}
                checked={selectedVersion === version}
                onChange={() => onVersionChange(version)}
              />
              {formatVersion(version)}
              {index === 0 && <S.LatestLabel>Latest</S.LatestLabel>}
            </S.VersionOption>
          ))}
        </S.VersionOptionsList>

        <S.ModalButtonContainer>
          <S.CancelButton onClick={onClose}>Cancel</S.CancelButton>
          <S.ConfirmButton onClick={onContinue}>Continue</S.ConfirmButton>
        </S.ModalButtonContainer>
      </S.ModalContent>
    </S.ModalOverlay>
  )
}

export default ManualVersionModal
